import styled from "styled-components";

export const ECModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ECModalTopSection = styled.form`
  display: flex;
  align-items: center;
  gap: 16px;
`;
